import React from 'react';
import { toast } from 'sonner';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, ChevronLeft, Globe, Shield, Activity, Share2 } from 'lucide-react';

export const AdvancedSettingsPage = () => {
    const navigate = useNavigate();

    const handleAdPrivacyClick = () => {
        toast.error('This option is only available for users in regions with specific privacy regulations (e.g., EU, UK).');
    };

    return (
        <main className="flex-1 w-full flex flex-col bg-transparent">
            {/* Header */}
            <div className="sticky top-0 bg-[#0a0a0a]/90 backdrop-blur-md z-40 border-b border-[#1a1a1a] flex items-center h-[60px] px-4">
                <button onClick={() => navigate('/settings')} className="sm:hidden w-10 h-10 flex items-center justify-center rounded-full hover:bg-white/10 transition-colors mr-2">
                    <ChevronLeft size={24} className="text-white" />
                </button>
                <h1 className="text-xl font-bold text-white">Advanced Settings</h1>
            </div>

            <div className="flex-1 overflow-y-auto p-4 sm:p-6 pb-20 sm:pb-0">
                
                <h2 className="text-sm font-bold text-gray-500 uppercase tracking-wider mb-4 px-2">Privacy & Consent</h2>

                <div className="bg-[#111] border border-[#222] rounded-xl overflow-hidden">
                    <button 
                        onClick={handleAdPrivacyClick}
                        className="w-full p-4 flex items-center justify-between hover:bg-[#1a1a1a] transition-colors"
                    >
                        <div className="flex items-center">
                            <div className="w-8 h-8 rounded-full bg-blue-500/10 flex items-center justify-center mr-3">
                                <Globe size={16} className="text-blue-500" />
                            </div>
                            <span className="text-white font-medium">Ad Privacy & Consent</span>
                        </div>
                        <ArrowLeft size={16} className="text-gray-500 rotate-180" />
                    </button>
                </div>
            </div>
        </main>
    );
};

export default AdvancedSettingsPage;
